// Central content + placeholders. Replace COMPANY details with the client's real data.
export const COMPANY = {
  name: "AccijnsAdvies.be",
  legalName: "AccijnsAdvies.be",
  tagline: "Belgische Accijns Expertise",
  address: "2940 Stabroek, België",
  vat: "BE 1033.034.261",
  email: "info@accijnsadvies.be",
  phone: "0492 87 23 22",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Onze Diensten", href: "#diensten" },
  { label: "Doelgroepen", href: "#doelgroepen" },
  { label: "Licentie Checker", href: "#checker" },
  { label: "Contact", href: "#contact" },
];

export const INDUSTRIES = [
  {
    id: "brouwerijen",
    title: "Brouwerijen, Stokerijen & Wijnmakers",
    focus:
      "Erkend Entrepothouder vergunningen, accijnsberekeningen, deel der engelen & verliezen.",
    image:
      "https://images.unsplash.com/photo-1651171052773-1f46b5894d6a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: "Beer",
    span: "lg:col-span-7",
  },
  {
    id: "energie",
    title: "Energieproducten & Elektriciteit",
    focus:
      "Verschillende accijnstarieven, vrijstellingen voor minerale oliën/elektriciteit, bulkvervoer, opslag, Handelaar/Eindgebruiker.",
    image:
      "https://images.pexels.com/photos/31587338/pexels-photo-31587338.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    icon: "Zap",
    span: "lg:col-span-5",
  },
  {
    id: "frisdrank",
    title: "Alcoholvrije Dranken & Koffie",
    focus:
      "Vergunningen accijnsinrichting, regeling nationale accijnsproducten, verpakkingsheffing.",
    image:
      "https://images.unsplash.com/photo-1561986810-4f3ba2f46ceb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: "Coffee",
    span: "lg:col-span-5",
  },
  {
    id: "transport",
    title: "Transport & Logistiek",
    focus:
      "EMCS & NEW AC4-beheer, fiscale vertegenwoordiging, vervoer onder schorsings- én 'accijns betaald'-regeling, opslag.",
    image:
      "https://images.unsplash.com/photo-1494412519320-aa613dfb7738?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: "Ship",
    span: "lg:col-span-7",
  },
];

export const SERVICES = [
  {
    id: "vergunningen",
    tab: "Vergunningen & Statuten",
    icon: "FileCheck2",
    title: "Vergunningen & Statuten",
    desc: "Begeleiding bij het aanvragen van de juiste accijnsvergunningen bij de Belgische Douane, en het correct beheren van uw voorraad.",
    points: [
      "Aanvraag Erkend Entrepothouder & andere statuten",
      "Correcte opzet van uw voorraadadministratie",
      "Zekerheidsstelling & waarborgberekening",
    ],
  },
  {
    id: "emcs",
    tab: "EMCS & NEW AC4",
    icon: "Workflow",
    title: "EMCS, NEW AC4 & Logistieke Flow",
    desc: "Volledige opmaak en digitale opvolging van uw accijnsdocumenten doorheen de hele logistieke keten.",
    points: [
      "e-AD opmaak & digitale opvolging",
      "NEW AC4 gecertificeerde flows",
      "Fiscale vertegenwoordiging bij vervoer",
    ],
  },
  {
    id: "quickscan",
    tab: "Quickscan & Audits",
    icon: "ShieldCheck",
    title: "Accijns Quickscan & Audits",
    desc: "Preventieve controle van uw accijnsregisters om boetes en naheffingen te voorkomen vóór de douane langskomt.",
    points: [
      "Doorlichting van registers & aangiftes",
      "Risico- en boeteanalyse",
      "Concreet actieplan met prioriteiten",
    ],
  },
  {
    id: "digitalisering",
    tab: "Digitalisering",
    icon: "Cpu",
    title: "Digitalisering & Inrichting",
    desc: "Integratie van accijnscodes in uw ERP- en voorraadsoftware voor een waterdichte, geautomatiseerde flow.",
    points: [
      "Accijnscodes in uw ERP/WMS",
      "Automatische aangiftes & rapportage",
      "Procesinrichting op maat",
    ],
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Lokale Kennis van Belgische Douanekantoren",
    desc: "Wij kennen de mensen, de dossiers en de verwachtingen van de Belgische Douane. Dat versnelt uw vergunningen en voorkomt misverstanden.",
  },
  {
    no: "02",
    title: "Preventief Advies",
    desc: "Voorkom boetes en naheffingen. We sporen risico's op vóór ze een probleem worden en houden uw registers waterdicht.",
  },
  {
    no: "03",
    title: "Operationele Hulp",
    desc: "Wij adviseren niet alleen, we voeren ook uit. Van vergunningsaanvraag tot dagelijkse EMCS-opvolging: wij nemen het werk uit handen.",
  },
];

export const PRODUCT_OPTIONS = [
  { value: "alcohol", label: "Bier / Wijn / Sterkedrank", icon: "Beer" },
  { value: "energie", label: "Energieproducten", icon: "Zap" },
  { value: "frisdrank", label: "Frisdrank / Koffie", icon: "Coffee" },
];

export const ACTIVITY_OPTIONS = [
  { value: "aankoop_eu", label: "Aankoop binnen de EU", icon: "ShoppingCart", needsRegime: true },
  { value: "verkoop_eu", label: "Verkoop binnen de EU", icon: "Send", needsRegime: true },
  { value: "import", label: "Invoer van buiten de EU", icon: "Globe" },
  { value: "productie", label: "Productie in België", icon: "Factory" },
  { value: "opslag", label: "Opslag", icon: "Warehouse" },
];

export const REGIME_OPTIONS = [
  { value: "geschorst", label: "Onder schorsing van accijns", icon: "Lock" },
  { value: "betaald", label: "Accijns reeds betaald", icon: "BadgeCheck" },
];

// Whether the chosen activity requires a follow-up regime question (only for
// alcohol/energy EU purchase or sale). Soft drinks/coffee never need it.
export function activityNeedsRegime(product, activity) {
  if (product === "frisdrank") return false;
  return activity === "aankoop_eu" || activity === "verkoop_eu";
}

export function resolveLicense(product, activity, regime) {
  // Soft drinks & coffee: every activity resolves to Accijnsinrichting.
  if (product === "frisdrank") {
    return {
      status: "Accijnsinrichting",
      reason:
        "Voor alcoholvrije dranken en koffie vallen alle activiteiten onder de regeling van de nationale accijnsproducten. U heeft een vergunning Accijnsinrichting nodig.",
      product,
      activity,
      regime,
    };
  }

  let status;
  let reason;

  switch (activity) {
    case "aankoop_eu":
      if (regime === "geschorst") {
        status = "Geregistreerde Geadresseerde of Erkend Entrepothouder";
        reason =
          "Bij aankoop binnen de EU onder schorsing van accijns ontvangt u de goederen als Geregistreerde Geadresseerde, of — bij eigen opslag onder schorsing — als Erkend Entrepothouder.";
      } else {
        status = "Gecertificeerd Geadresseerde";
        reason =
          "Bij aankoop binnen de EU van reeds veraccijnsde goederen (B2B) is sinds de NEW AC4-regeling het statuut Gecertificeerd Geadresseerde vereist.";
      }
      break;
    case "verkoop_eu":
      if (regime === "geschorst") {
        status = "Erkend Entrepothouder";
        reason =
          "Bij verkoop binnen de EU onder schorsing van accijns verzendt u de goederen vanuit uw belastingentrepot als Erkend Entrepothouder.";
      } else {
        status = "Gecertificeerde Afzender";
        reason =
          "Bij verkoop binnen de EU van reeds veraccijnsde goederen (B2B) treedt u op als Gecertificeerde Afzender onder de NEW AC4-regeling.";
      }
      break;
    case "import":
      status = "Geregistreerde Afzender";
      reason =
        "Bij invoer van buiten de EU met doorvoer onder schorsing verzendt u de goederen als Geregistreerde Afzender via EMCS.";
      break;
    case "productie":
    case "opslag":
    default:
      status = "Erkend Entrepothouder";
      reason =
        "Voor productie of opslag onder de accijnsschorsingsregeling heeft u een belastingentrepot en het statuut van Erkend Entrepothouder nodig.";
      break;
  }

  return { status, reason, product, activity, regime };
}
